import { gql } from '@apollo/client'
import {
  IDEAL_DISPLAY_INVENTORY_FACING_FRAGMENT,
  SHELF_SCAN_FRAGMENT,
  STORE_FRAGMENT,
} from '../fragments'

export const GET_SCAN_GROUP_FOR_POG_COMPLIANCE = gql`
  query GetScanGroupForPOGCompliance($scanId: ID!) {
    scanGroup(scanId: $scanId) {
      created
      complianceScore {
        score
      }
      planogram {
        segments {
          shelves {
            idealInventory {
              ...IdealDisplayInventoryFacing
            }
          }
        }
      }
      scans {
        shelfScans {
          ...ShelfScan
        }
        keyframes
      }
    }
  }
  ${SHELF_SCAN_FRAGMENT}
  ${IDEAL_DISPLAY_INVENTORY_FACING_FRAGMENT}
`
